import { api } from '../../../lib/api'

export const GET_STATISTICS_BY_DOMAIN_REQUEST = 'GET_STATISTICS_BY_DOMAIN_REQUEST'
export const GET_STATISTICS_BY_DOMAIN_SUCCESS = 'GET_STATISTICS_BY_DOMAIN_SUCCESS'
export const GET_STATISTICS_BY_DOMAIN_FAILED = 'GET_STATISTICS_BY_DOMAIN_FAILED'

export const GET_STATISTICS_BY_CATEGORY_REQUEST = 'GET_STATISTICS_BY_CATEGORY_REQUEST'
export const GET_STATISTICS_BY_CATEGORY_SUCCESS = 'GET_STATISTICS_BY_CATEGORY_SUCCESS'
export const GET_STATISTICS_BY_CATEGORY_FAILED = 'GET_STATISTICS_BY_CATEGORY_FAILED'

export const GET_STATISTICS_BY_DOMAIN_BY_DAYS_REQUEST = 'GET_STATISTICS_BY_DOMAIN_BY_DAYS_REQUEST'
export const GET_STATISTICS_BY_DOMAIN_BY_DAYS_SUCCESS = 'GET_STATISTICS_BY_DOMAIN_BY_DAYS_SUCCESS'
export const GET_STATISTICS_BY_DOMAIN_BY_DAYS_FAILED = 'GET_STATISTICS_BY_DOMAIN_BY_DAYS_FAILED'

export const GET_LOG_STATISTICS_REQUEST = 'GET_LOG_STATISTICS_REQUEST'
export const GET_LOG_STATISTICS_SUCCESS = 'GET_LOG_STATISTICS_SUCCESS'
export const GET_LOG_STATISTICS_FAILED = 'GET_LOG_STATISTICS_FAILED'

export const GET_LOG_STATISTICS_PDF_REQUEST = 'GET_LOG_STATISTICS_PDF_REQUEST'
export const GET_LOG_STATISTICS_PDF_SUCCESS = 'GET_LOG_STATISTICS_PDF_SUCCESS'
export const GET_LOG_STATISTICS_PDF_FAILED = 'GET_LOG_STATISTICS_PDF_FAILED'

export const GET_LOG_TYPES_REQUEST = 'GET_LOG_TYPES_REQUEST'
export const GET_LOG_TYPES_SUCCESS = 'GET_LOG_TYPES_SUCCESS'
export const GET_LOG_TYPES_FAILED = 'GET_LOG_TYPES_FAILED'

export const GET_STATISTICS_FOR_STORIES_REQUEST = 'GET_STATISTICS_FOR_STORIES_REQUEST'
export const GET_STATISTICS_FOR_STORIES_SUCCESS = 'GET_STATISTICS_FOR_STORIES_SUCCESS'
export const GET_STATISTICS_FOR_STORIES_FAILED = 'GET_STATISTICS_FOR_STORIES_FAILED'

export const getUserStatistics = function (domainId) {
  return function (dispatch) {
    dispatch({
      type: GET_STATISTICS_BY_DOMAIN_REQUEST
    })
    return api.getUserStatistics().then((getStatisticsByDomainResponse) => {
      dispatch({
        type: GET_STATISTICS_BY_DOMAIN_SUCCESS,
        payload: getStatisticsByDomainResponse
      })
    }).catch((error) => {
      dispatch({
        type: GET_STATISTICS_BY_DOMAIN_FAILED,
        error
      })
    })
  }
}

export const getStatisticsByDomainSuperAdmin = function (domainId) {
  return function (dispatch) {
    dispatch({
      type: GET_STATISTICS_BY_DOMAIN_REQUEST
    })
    api.getStatisticsByDomainSuperAdmin(domainId).then((getStatisticsByDomainResponse) => {
      dispatch({
        type: GET_STATISTICS_BY_DOMAIN_SUCCESS,
        payload: getStatisticsByDomainResponse
      })
    }).catch((error) => {
      dispatch({
        type: GET_STATISTICS_BY_DOMAIN_FAILED,
        error
      })
    })
  }
}

export const getStatisticsByCategory = function (categoryId) {
  return function (dispatch) {
    dispatch({
      type: GET_STATISTICS_BY_CATEGORY_REQUEST
    })
    api.getStatisticsByCategory(categoryId).then((getStatisticsByCategoryResponse) => {
      dispatch({
        type: GET_STATISTICS_BY_CATEGORY_SUCCESS,
        payload: getStatisticsByCategoryResponse
      })
    }).catch((error) => {
      dispatch({
        type: GET_STATISTICS_BY_CATEGORY_FAILED,
        error
      })
    })
  }
}

export const getStatisticsByDomainByDays = function (domainId, from, until) {
  return function (dispatch) {
    dispatch({
      type: GET_STATISTICS_BY_DOMAIN_BY_DAYS_REQUEST
    })
    api.getStatisticsByDomainByDays(domainId, from, until).then((getStatisticsByDomainByDaysResponse) => {
      dispatch({
        type: GET_STATISTICS_BY_DOMAIN_BY_DAYS_SUCCESS,
        payload: getStatisticsByDomainByDaysResponse
      })
    }).catch((error) => {
      dispatch({
        type: GET_STATISTICS_BY_DOMAIN_BY_DAYS_FAILED,
        error
      })
    })
  }
}

export const getLogStatistics = options => (dispatch) => {
  dispatch({
    type: GET_LOG_STATISTICS_REQUEST
  })

  api.getLogStatistics(options).then((getLogStatisticsResponse) => {
    dispatch({
      type: GET_LOG_STATISTICS_SUCCESS,
      payload: getLogStatisticsResponse
    })
  }).catch((error) => {
    dispatch({
      type: GET_LOG_STATISTICS_FAILED,
      error
    })
  })
}

export const getLogStatisticsSuperAdmin = options => (dispatch) => {
  dispatch({
    type: GET_LOG_STATISTICS_REQUEST
  })

  api.getLogStatisticsSuperAdmin(options).then((getLogStatisticsResponse) => {
    dispatch({
      type: GET_LOG_STATISTICS_SUCCESS,
      payload: getLogStatisticsResponse
    })
  }).catch((error) => {
    dispatch({
      type: GET_LOG_STATISTICS_FAILED,
      error
    })
  })
}

export const downloadStatisticsFile = options => (dispatch) => {
  dispatch({
    type: GET_LOG_STATISTICS_PDF_REQUEST
  })

  api.getLogStatistics(options).then((getLogStatisticsPdfResponse) => {
    dispatch({
      type: GET_LOG_STATISTICS_PDF_SUCCESS,
      payload: getLogStatisticsPdfResponse
    })
  }).catch((error) => {
    dispatch({
      type: GET_LOG_STATISTICS_PDF_FAILED,
      error
    })
  })
}

export const getLogTypes = () => (dispatch) => {
  dispatch({
    type: GET_LOG_TYPES_REQUEST
  })

  api.getLogTypes().then((getLogTypesResponse) => {
    dispatch({
      type: GET_LOG_TYPES_SUCCESS,
      payload: getLogTypesResponse
    })
  }).catch((error) => {
    dispatch({
      type: GET_LOG_TYPES_FAILED,
      error
    })
  })
}



// WEBPACK FOOTER //
// ./src/redux/actions/statistics/get-statistics.js